/**
 * HouseNord Cart Drawer
 * Intercepts add-to-cart form submissions site-wide (product page and
 * product card quick-add) and the header cart icon, using Shopify's
 * Ajax Cart API (/cart/add.js, /cart/change.js, /cart.js) instead of
 * full page navigation.
 */
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var itemsEl = document.getElementById('cart-drawer-items');
  var countEl = document.getElementById('cart-drawer-count');
  var countSEl = document.getElementById('cart-drawer-count-s');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var titleEl = document.getElementById('cart-drawer-title');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function openDrawer(justAdded) {
    titleEl.textContent = justAdded ? 'Added to your bag' : 'Your Bag';
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function renderCart(cart) {
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    countEl.textContent = cart.item_count;
    countSEl.textContent = cart.item_count === 1 ? '' : 's';
    subtotalEl.textContent = money(cart.total_price);

    itemsEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'cart-drawer__item';

      var img = document.createElement('img');
      img.src = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_200x200$1$2') : '';
      img.alt = item.product_title || item.title;
      row.appendChild(img);

      var info = document.createElement('div');
      info.className = 'cart-drawer__item-info';

      var titleHtml = '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title || item.title) + '</p>';
      var optsHtml = '';
      (item.options_with_values || []).forEach(function (opt) {
        if (opt.value && opt.value.toLowerCase() !== 'default title') {
          optsHtml += '<p class="cart-drawer__item-opt">' + escapeHtml(opt.name) + ': ' + escapeHtml(opt.value) + '</p>';
        }
      });
      var priceHtml = '<p class="cart-drawer__item-price">' + money(item.final_price) + '</p>';
      info.innerHTML = titleHtml + optsHtml + priceHtml;

      var rowCtrl = document.createElement('div');
      rowCtrl.className = 'cart-drawer__item-row';

      var qty = document.createElement('div');
      qty.className = 'cart-drawer__qty';
      var dec = document.createElement('button');
      dec.type = 'button'; dec.textContent = '−';
      dec.addEventListener('click', function () { changeQuantity(item.key, item.quantity - 1); });
      var qtySpan = document.createElement('span');
      qtySpan.textContent = item.quantity;
      var inc = document.createElement('button');
      inc.type = 'button'; inc.textContent = '+';
      inc.addEventListener('click', function () { changeQuantity(item.key, item.quantity + 1); });
      qty.appendChild(dec); qty.appendChild(qtySpan); qty.appendChild(inc);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'cart-drawer__remove';
      removeBtn.textContent = 'Remove';
      removeBtn.addEventListener('click', function () { changeQuantity(item.key, 0); });

      rowCtrl.appendChild(qty);
      rowCtrl.appendChild(removeBtn);
      info.appendChild(rowCtrl);

      row.appendChild(info);
      itemsEl.appendChild(row);
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      updateHeaderCount(cart.item_count);
      return cart;
    });
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function changeQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateHeaderCount(cart.item_count);
      })
      .catch(function () { /* leave state as-is on network error */ });
  }

  function showFormError(form, message) {
    var existing = form.querySelector('.cart-drawer__form-error');
    if (existing) existing.remove();
    var el = document.createElement('p');
    el.className = 'cart-drawer__form-error';
    el.style.cssText = 'color:#c0392b;font-size:12px;margin-top:8px';
    el.textContent = message;
    form.appendChild(el);
  }

  function handleAddToCart(form, submitter) {
    var formData = new FormData(form);
    var originalText = submitter ? submitter.textContent : null;
    if (submitter) {
      submitter.disabled = true;
      submitter.textContent = 'Adding…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (result) {
        if (submitter) {
          submitter.disabled = false;
          submitter.textContent = originalText;
        }
        if (!result.ok) {
          showFormError(form, result.data && result.data.description || 'Could not add to bag — please try again.');
          return;
        }
        refreshCart().then(function () { openDrawer(true); });
      })
      .catch(function () {
        if (submitter) {
          submitter.disabled = false;
          submitter.textContent = originalText;
        }
        showFormError(form, 'Could not add to bag — check your connection and try again.');
      });
  }

  // Intercept add-to-cart form submissions site-wide
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    var submitter = e.submitter;
    if (submitter && submitter.name && submitter.name !== 'add') return; // let express checkout buttons behave normally
    e.preventDefault();
    handleAddToCart(form, submitter);
  });

  // Header cart icon opens the drawer instead of navigating
  document.querySelectorAll('.hdr-cart').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(function () { openDrawer(false); });
    });
  });

  // Close interactions
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Also make the full /cart page's native "Remove" links (item.url_to_remove)
  // use the same reliable AJAX endpoint instead of a full navigation. This
  // avoids the "no valid id or line parameter" Shopify error page, which
  // happens when that page is showing stale/cached line-item positions —
  // an AJAX call always targets the live cart state instead.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/cart/change"]');
    if (!link) return;
    e.preventDefault();
    var url = new URL(link.href, window.location.origin);
    var line = url.searchParams.get('line');
    var id = url.searchParams.get('id');
    var quantity = url.searchParams.get('quantity') || '0';
    var payload = id ? { id: id, quantity: quantity } : { line: line, quantity: quantity };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  });
})();
